
const Utils = {

  IPtoNum (ip) {
    return Number(
      ip.split(".")
        .map(d => ("000" + d).substr(-3))
        .join("")
    );
  }

}

export default Utils;
